import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizeRouterModule } from 'localize-router';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AccordionModule } from 'src/app/shared/accordion/accordion.module';
import { UtilityService } from '../services/utility.service';
import { CollapseModule } from './collapse/collapse.module';
import { DatatableModule } from './datatable/datatable.module';
import { DisplayModule } from './display/display.module';
import { InputsModule } from './inputs/inputs.module';
import { NotificationModule } from './notification/notification.module';
import { NewsPopupModule } from './news-popup/news-popup.module';
import { AnnouncementBarModule } from './announcement-bar/announcement-bar.module';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    LocalizeRouterModule,
    BsDropdownModule.forRoot(),
    BsDatepickerModule.forRoot(),

    InputsModule,
    NotificationModule,
    DatatableModule,
    DisplayModule,
    CollapseModule,
    AccordionModule,
    NewsPopupModule,
    AnnouncementBarModule
  ],
  exports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    LocalizeRouterModule,
    BsDropdownModule,
    BsDatepickerModule,

    InputsModule,
    NotificationModule,
    DatatableModule,
    DisplayModule,
    CollapseModule,
    AccordionModule,
    NewsPopupModule,
    AnnouncementBarModule,
    NgbDatepickerModule
    // Component
  ],
  providers: [
    UtilityService
  ]
})
export class SharedModule {
}
